export enum RoutePath {
  UPLOAD_CLAUSE = '/upload-clause',
  UPLOAD_FILES = '/upload-files',
  UPLOAD_FILES_LIST_VIEW = 'list',
  UPLOAD_FILES_SPREADSHEET_VIEW = 'spreadsheet',
  DOCUMENTS = '/documents',
  LOGIN = '/login',
  LOGOUT = '/logout',
  SETTINGS = '/settings',
  ADMIN_PANEL = '/admin-panel',
  SETTINGS_ACCOUNT = 'account',
  SETTINGS_NOTIFICATIONS = 'notifications',
  SETTINGS_SAVED_SEARCHES = 'saved-searches',
  NOT_FOUND = '/not-found',
  NO_ACCESS = '/no-access',
  NO_WRITE_ACCESS = '/no-write-access',
  CLAUSES = '/clauses',
  BOOKMARKS = '/bookmarks',
  BOOKMARKS_DOCUMENTS = 'documents',
  BOOKMARKS_CLAUSES = 'clauses',
  UPLOADED_DOCUMENTS = '/my-files/uploaded-documents',
  REPORTED_DOCUMENTS = '/my-files/reported-documents',
  UPLOADED_DOCUMENTS_LIST_VIEW = 'list',
  UPLOADED_DOCUMENTS_SPREADSHEET_VIEW = 'spreadsheet',
  UPLOADED_DOCUMENTS_PENDING = 'pending',
  UPLOADED_CLAUSES = '/my-files/uploaded-clauses',
  REPORTED_CLAUSES = '/my-files/reported-clauses',
  UPLOADED_CLAUSES_LIST_VIEW = 'list',
  UPLOADED_CLAUSES_PENDING = 'pending',
  REPORTS = '/reports',
  SANDBOX_DOCUMENTS = '/sandbox/documents',
  SANDBOX_CLAUSES = '/sandbox/clauses',
  MY_REPORTS = 'my-reports',
  REPORTS_REPORTS = 'reports',
  SIMILAR = 'similar',
  ID = ':id',
  BOOKMARK_ID = ':bookmark_id',
  CLAUSE_ID = ':clause_id',
}

export const getRoutePath = (base: RoutePath, path: RoutePath) => `${base}/${path}`;

export const getChildPath = (base: RoutePath) => `${base}/*`;

export const DOCUMENT_ID_PATH = getRoutePath(RoutePath.DOCUMENTS, RoutePath.ID) as RoutePath;
export const SANDBOX_DOCUMENTS_ID_PATH = getRoutePath(
  RoutePath.SANDBOX_DOCUMENTS,
  RoutePath.ID
) as RoutePath;

export const SIMILAR_CLAUSE_ID_PATH = getRoutePath(
  RoutePath.SIMILAR,
  RoutePath.CLAUSE_ID
) as RoutePath;

export const DOCUMENT_ID_SIMILAR_CLAUSE_ID_PATH = getRoutePath(
  DOCUMENT_ID_PATH,
  SIMILAR_CLAUSE_ID_PATH
) as RoutePath;
export const SANDBOX_DOCUMENTS_ID_SIMILAR_CLAUSE_ID_PATH = getRoutePath(
  SANDBOX_DOCUMENTS_ID_PATH,
  SIMILAR_CLAUSE_ID_PATH
) as RoutePath;
